/* Space Coast 3D — carousels, cart drawer, add to cart. */
(function () {
	'use strict';

	var $ = function (sel, root) { return (root || document).querySelector(sel); };
	var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
	var cfg = window.SC3D || {};

	/* ---------- Carousels ---------- */
	$$('.sc-carousel').forEach(function (car) {
		var slides = $$('.sc-slide', car);
		var dots = $$('.sc-dots button', car);
		if (slides.length < 2) { return; }
		var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
		var paused = false;
		var show = function (n) {
			i = (n + slides.length) % slides.length;
			slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
			dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
		};
		$('.sc-car-prev', car).addEventListener('click', function () { show(i - 1); });
		$('.sc-car-next', car).addEventListener('click', function () { show(i + 1); });
		dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
		var ms = parseInt(car.getAttribute('data-autoplay'), 10) || 0;
		if (ms) {
			car.addEventListener('mouseenter', function () { paused = true; });
			car.addEventListener('mouseleave', function () { paused = false; });
			setInterval(function () { if (!paused && !document.hidden) { show(i + 1); } }, ms);
		}
	});

	/* ---------- Mobile nav ---------- */
	var toggle = $('.sc-navtoggle');
	if (toggle) {
		toggle.addEventListener('click', function () {
			var open = document.body.classList.toggle('sc-nav-open');
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
		$$('.sc-nav a').forEach(function (a) {
			a.addEventListener('click', function () { document.body.classList.remove('sc-nav-open'); });
		});
	}

	/* ---------- Cart drawer ---------- */
	var drawer = $('.sc-drawer');
	var itemsEl = $('.js-sc-drawer-items');

	var money = function (cents) { return (cfg.symbol || '$') + (cents / 100).toFixed(2); };
	var esc = function (s) {
		return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
		});
	};

	var openCart = function () {
		if (!drawer) { return; }
		drawer.classList.add('is-open');
		drawer.setAttribute('aria-hidden', 'false');
	};
	var closeCart = function () {
		if (!drawer) { return; }
		drawer.classList.remove('is-open');
		drawer.setAttribute('aria-hidden', 'true');
	};

	/* How a cart line is described, matching the design:
	   filament  -> "Name · Single refill (1 kg)" / "$13.50 / kg", or "Name · Case of 10" / "$80.00 / case"
	   build kit -> "Name · PETG Blue / TPU Black"
	   other     -> "Name" */
	var describe = function (item) {
		var name = item.product_title;
		var price = money(item.final_price);
		var opts = (item.options_with_values || []).filter(function (o) { return o.name !== 'Title'; });
		var pack = opts.filter(function (o) { return o.name === 'Pack'; })[0];
		if (pack) {
			var caseOf = pack.value.match(/^Case of (\d+)/i);
			var multi = pack.value.match(/^(\d+)-pack$/i);
			if (caseOf) {
				name += ' · ' + pack.value + ' (' + caseOf[1] + ' kg)';
				price += ' / case';
			} else if (multi) {
				name += ' · ' + pack.value + ' (' + multi[1] + ' kg)';
				price += ' / ' + pack.value.toLowerCase();
			} else {
				name += ' · Single ' + ((window.SC3D.refillHandles || []).indexOf(item.handle) > -1 ? 'refill' : 'spool') + ' (1 kg)';
				price += ' / kg';
			}
		} else if (opts.length) {
			// "PETG color (10 kg): Blue" -> "PETG Blue"; "Rear caster color: Red" -> "Caster Red";
			// a plain "Color: Gray" or "Rear caster color" on its own product -> just the value.
			var labelled = opts.length > 1;
			name += ' · ' + opts.map(function (o) {
				if (!labelled) { return o.value; }
				if (/caster/i.test(o.name)) { return 'Caster ' + o.value; }
				return o.name.indexOf(' ') > -1 ? o.name.split(' ')[0] + ' ' + o.value : o.value;
			}).join(' / ');
		}
		return { name: name, price: price };
	};

	var renderCart = function (cart) {
		if (!cart || !itemsEl) { return; }
		$$('.js-sc-count').forEach(function (el) { el.textContent = cart.item_count; });
		$$('.js-sc-subtotal').forEach(function (el) { el.textContent = money(cart.total_price); });
		// Free shipping progress: "You're $40.10 away from free shipping" / "You've got free shipping".
		$$('.js-sc-freeship').forEach(function (el) {
			var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
			var total = cart.total_price || 0;
			el.hidden = !threshold || !cart.item_count;
			var text = $('.js-sc-freeship-text', el);
			var bar = $('.js-sc-freeship-bar', el);
			if (text) {
				var area = el.getAttribute('data-area') ? ' ' + el.getAttribute('data-area') : '';
				text.innerHTML = total >= threshold ? '<strong>You\'ve got free shipping</strong>' + esc(area) : 'You\'re <strong>' + esc(money(threshold - total)) + '</strong> away from free shipping' + esc(area);
			}
			if (bar) { bar.style.width = Math.min(100, threshold ? (total / threshold) * 100 : 0) + '%'; }
			el.classList.toggle('is-done', total >= threshold);
		});
		$$('.js-sc-savings').forEach(function (el) {
			el.hidden = !cart.total_discount;
			var v = el.querySelector('strong');
			if (v) { v.textContent = '−' + money(cart.total_discount || 0); }
		});
		if (!cart.items.length) {
			itemsEl.innerHTML = '<div class="sc-drawer__empty">Your cart is empty.<br><a href="' + esc(cfg.shopUrl || '/collections/all') + '">Browse the shop →</a></div>';
			return;
		}
		itemsEl.innerHTML = cart.items.map(function (item) {
			var d = describe(item);
			var img = item.image ? '<img src="' + esc(item.image) + '" alt="">' : '';
			return '<div class="sc-line">' +
				'<div class="sc-line__thumb">' + img + '</div>' +
				'<div class="sc-line__text"><div class="sc-line__name">' + esc(d.name) + '</div><div class="sc-line__price">' + esc(d.price) + '</div></div>' +
				'<div class="sc-line__qty">' +
				'<button type="button" class="js-sc-qty" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
				'<span>' + item.quantity + '</span>' +
				'<button type="button" class="js-sc-qty" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
				'</div></div>';
		}).join('');
	};

	var request = function (url, body) {
		var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
		if (body) {
			opts.method = 'POST';
			opts.headers['Content-Type'] = 'application/json';
			opts.body = JSON.stringify(body);
		}
		return fetch(url, opts).then(function (r) {
			return r.json().then(function (data) {
				if (!r.ok) { throw new Error(data.description || data.message || 'Sorry, something went wrong.'); }
				return data;
			});
		});
	};

	var refreshCart = function () {
		return request((cfg.cartUrl || '/cart') + '.js').then(renderCart);
	};

	// Signed-in Make Good members: put the member discount codes on the cart. Shopify
	// decides at checkout whether each code still applies (eligibility, once per member).
	var applyMemberCodes = function () {
		if (!cfg.memberCodes) { return Promise.resolve(); }
		return request((cfg.cartUpdateUrl || '/cart/update') + '.js', { discount: cfg.memberCodes }).catch(function () {});
	};

	var addToCart = function (variantId, qty, btn, errorEl) {
		if (btn) { btn.disabled = true; }
		if (errorEl) { errorEl.hidden = true; }
		request((cfg.cartAddUrl || '/cart/add') + '.js', { items: [{ id: Number(variantId), quantity: qty }] })
			.then(applyMemberCodes)
			.then(refreshCart)
			.then(openCart)
			.catch(function (err) {
				if (errorEl) {
					errorEl.textContent = err.message;
					errorEl.hidden = false;
				} else {
					window.alert(err.message);
				}
			})
			.then(function () { if (btn) { btn.disabled = false; } });
	};

	document.addEventListener('click', function (e) {
		var t = e.target;
		if (!t.closest) { return; }

		if (t.closest('.js-sc-cart-open')) { refreshCart().catch(function () {}); openCart(); return; }
		if (t.closest('.js-sc-cart-close')) { closeCart(); return; }

		var add = t.closest('.js-sc-add');
		if (add) {
			addToCart(add.getAttribute('data-variant'), 1, add);
			return;
		}

		var q = t.closest('.js-sc-qty');
		if (q) {
			q.disabled = true;
			request((cfg.cartChangeUrl || '/cart/change') + '.js', { id: q.getAttribute('data-key'), quantity: Math.max(0, parseInt(q.getAttribute('data-qty'), 10) || 0) })
				.then(renderCart)
				.catch(function () { refreshCart(); });
			return;
		}

		var step = t.closest('.js-sc-step');
		if (step) {
			var form = step.closest('form');
			var val = step.parentNode.querySelector('.js-sc-qtyval');
			var n = Math.max(1, (parseInt(val.textContent, 10) || 1) + parseInt(step.getAttribute('data-delta'), 10));
			val.textContent = n;
			var input = form && $('.js-sc-qty-input', form);
			if (input) { input.value = n; }
		}
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') { closeCart(); }
	});

	/* ---------- Product page ---------- */
	$$('.js-sc-buy').forEach(function (form) {
		var idInput = $('.js-sc-variant-id', form);
		var addBtn = $('.sc-buy__add', form);
		var errorEl = $('.sc-buy__error', form);
		var priceEl = $('.js-sc-price');
		var unitEl = $('.js-sc-unit');

		// Filament: one dropdown of packs.
		var pack = $('.js-sc-pack', form);
		if (pack) {
			var syncPack = function () {
				var o = pack.options[pack.selectedIndex];
				idInput.value = pack.value;
				if (priceEl) { priceEl.textContent = o.getAttribute('data-price'); }
				if (unitEl) { unitEl.textContent = o.getAttribute('data-unit'); }
			};
			pack.addEventListener('change', syncPack);
			syncPack();
		}

		// Build kit: one dropdown per option; find the matching variant.
		var selects = $$('.js-sc-option', form);
		var variantsEl = $('.js-sc-variants', form);
		if (selects.length && variantsEl) {
			var variants = [];
			try { variants = JSON.parse(variantsEl.textContent); } catch (err) { variants = []; }
			// Each choice's own part stock (see main-product.liquid), e.g. {"1": {"Blue": true}}.
			var optionStock = {};
			var stockEl = $('.js-sc-option-stock', form);
			if (stockEl) {
				try { optionStock = JSON.parse(stockEl.textContent); } catch (err) { optionStock = {}; }
			}
			var syncOptions = function () {
				var chosen = selects.map(function (s) { return s.value; });
				var match = variants.filter(function (v) {
					return v.options.every(function (val, k) { return val === chosen[k]; });
				})[0];
				if (match) {
					idInput.value = match.id;
					if (priceEl) { priceEl.textContent = match.price; }
				}
				if (addBtn) {
					addBtn.disabled = !match || !match.available;
					addBtn.textContent = !match ? 'Unavailable' : (match.available ? 'Add to cart' : 'Sold out');
				}
				// Mark a choice sold out by its own part's stock, so a sold-out PETG doesn't make
				// the TPU and caster colors look sold out too; the button shows when the chosen
				// combination can't be bought. Choices that aren't a known part fall back to
				// "no buyable combination contains it".
				selects.forEach(function (s, k) {
					Array.prototype.forEach.call(s.options, function (o) {
						if (!o.hasAttribute('data-label')) { o.setAttribute('data-label', o.textContent); }
						var own = optionStock[k] ? optionStock[k][o.value] : null;
						var inStock = (own === true || own === false) ? own :
							variants.some(function (v) { return v.available && v.options[k] === o.value; });
						o.textContent = o.getAttribute('data-label') + (inStock ? '' : ' (sold out)');
					});
				});
			};
			selects.forEach(function (s) { s.addEventListener('change', syncOptions); });
			syncOptions();

			// A single colour choice shows the matching photo (photos are in the same order as the colours).
			var photoDots = $$('.sc-pdp__carousel .sc-dots button');
			if (selects.length === 1 && photoDots.length === selects[0].options.length) {
				selects[0].addEventListener('change', function () { photoDots[selects[0].selectedIndex].click(); });
			}
		}

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			var qty = parseInt($('.js-sc-qtyval', form).textContent, 10) || 1;
			addToCart(idInput.value, qty, addBtn, errorEl);
		});
	});

	/* Keep the header count and drawer current on cached pages. */
	if (drawer) { applyMemberCodes().then(refreshCart).catch(function () {}); }
})();
